import React, { useEffect, useState } from 'react';
import Crud_Catalogos from '../../herramientas/Crud_Catalogos';
import './GpsInfo.css';
import { timeToDateFill } from "../../herramientas/DateFormat";
import { CircularProgress } from '@mui/material';
import ModalLay from '../../components/ModalLay/ModalLay';
import { MovimientoGpsEvidenciaModal } from '../../components/MovimientoGpsEvidenciaModal/MovimientoGpsEvidenciaModal';

const ValidacionMovimientoGps = ({ accion, idusuario, idmovimiento, esfull, idGps, registro, refrescar, reset, cerrarModal }) => {

    const [informacionGps, setInformacionGps] = useState({});
    const [mostrarMensaje, setMostrarMensaje] = useState(false);
    const [loading, setLoading] = useState(true);
    const [nombreGpsFull, setNombreGpsFull] = useState('');

    const [usuariosLog, setUsuarioslog] = useState({
      idBitacoraMonitoreo: 5,
      idUsuario: idusuario,
      idMovimiento: idmovimiento,
      accionFecha: timeToDateFill(new Date().getTime()),
      descripcion: "Validacion de GPS: " + registro.gps,
      idPlataformaTipo: registro.idPlataformaTipo,      
    });
    
    useEffect(() => {
        //console.log("cerrarModal", cerrarModal);
        //console.log("idusuario", idusuario);
        //console.log("idmovimiento", idmovimiento);
        //console.log("esfull", esfull);
        console.log("registro", registro);
        //console.log("accion", accion);
        //console.log("idGps", idGps);
        //console.log("plataforma id gpsgate", registro.plataformaIdGpsgate );
        //console.log(usuariosLog);
        if(!idGps){
          crud("get", "", "", "movimientoGps/movimiento/"+esfull, "movimientoGps");
        } else {
          crud("get", "", "", "gpsestatus/plataforma/"+registro.plataformaIdGpsgate+"/gps/"+idGps, "apiGpsgate");
        }
        
    }, [idGps]);

    useEffect(() => {
      //console.log(informacionGps.length === undefined)
      if (informacionGps.length === undefined) {
        const timer = setTimeout(() => {
          setMostrarMensaje(true);     
          setLoading(false);     
        }, 2000); // Retraso de 2 segundos  
        return () => clearTimeout(timer); // Limpieza del timer al desmontar
      } else {
        setMostrarMensaje(false);
      }
    }, [informacionGps]);


    const crud = (metodo = "get", obj = [], id = "", catalogo = "", stateVar = "", hiddenModl = "") => {    
      //console.log(catalogo)  
      return Crud_Catalogos(catalogo, "", metodo, id, obj, "", stateVar, hiddenModl, []).then((returnVal) => {
            //console.log(returnVal)
        switch (metodo) {
                case "get": 
                  if(stateVar === "apiGpsgate" && returnVal) {
                    //console.log(returnVal);              
                    setInformacionGps(returnVal);
                    setLoading(false);
                  } 
                  if(stateVar === "movimientoGps" && returnVal) {
                    //console.log(returnVal);
                    // Verificar que returnVal es un array con al menos un elemento
                    if (Array.isArray(returnVal) && returnVal.length > 0) {
                      if (returnVal[0]?.gps?.id) {
                        const gpsId = returnVal[0].gps.id;
                        setNombreGpsFull(returnVal[0].gps.nombre); 
                        crud("get", "", "", "gpsestatus/plataforma/"+registro.plataformaIdGpsgate+"/gps/"+gpsId, "apiGpsgate");                        
                      }
                    }
                  }               
                break; 
                case "put":
                  if(stateVar === "usuarioValidaGps" && returnVal) {
                    //console.log("usuarioValidaGps: " + returnVal); 
                    if(registro.gps === null || registro.gps === undefined){
                      const usuariosLogActualizado = {
                        ...usuariosLog,                        
                        descripcion: "El gps esta colocado en el movimiento en full: " + esfull,
                      }
                      crud("post", usuariosLogActualizado , "", "usuariosLog", "usuariosLog");
                    } else {
                      crud("post", usuariosLog , "", "usuariosLog", "usuariosLog"); 
                    }                                                           
                    refrescar();
                    cerrarModal();
                  } 
                  if(stateVar === "usuarioValidaGpsFull" && returnVal) {
                    //console.log("usuarioValidaGps" + returnVal);  
                    const usuariosLogActualizado = {
                      ...usuariosLog,
                      idMovimiento: esfull,
                      descripcion: "Validacion de GPS en full: " + nombreGpsFull,
                    }
                    crud("post", usuariosLogActualizado , "", "usuariosLog", "usuariosLog");                                 
                    refrescar();
                    cerrarModal();
                  } 
                break;          
                default:
                    break;
            }
        }).catch(err => { console.log(err); });
      } 

    const isEmpty = (obj) => Object.keys(obj).length === 0;

    // Función para manejar la validación de la información
    const validarGps = (idmovimiento, esfull) => {
      crud("put", {"idmovimiento": idmovimiento} , "", "movimientosPatio/usuarioValidaGps/" + idusuario + "/" + idmovimiento, "usuarioValidaGps");                     
      if(esfull !== null && esfull !== undefined){
        crud("put", {"idmovimiento": esfull} , "", "movimientosPatio/usuarioValidaGps/" + idusuario + "/" + esfull, "usuarioValidaGpsFull");
      }
    };

    // Función para manejar el reseteo de la información
    const resetGps = (idmovimiento) => {
      reset(idmovimiento);
      cerrarModal();
    };


    // Componentes para la información básica del movimiento
    const MovimientoGps = ({ idmovimiento, esfull, registro, nombreGpsFull }) => {
      return (
        <>
          <tr>
            <td>Id Movimiento:</td>   
            <td><strong>{idmovimiento}</strong></td>            
          </tr>
          {![null, ""].includes(esfull) ?
            <tr>
              <td>En full:</td>   
              <td><strong>{esfull}</strong></td>            
            </tr>
          : null
          }   
          <tr>
            <td>Gps:</td>   
            <td><strong>{registro.gps}</strong></td>            
          </tr>  
          {![null, ""].includes(esfull) ?
            <tr>
              <td>Gps full:</td>   
              <td><strong>{nombreGpsFull}</strong></td>            
            </tr>
          : null
          }
        </>
      );
    };

    const InformacionGps = ({ informacionGps }) => {
      return (
        <>
          <tr>
            <th><strong>Latitud:</strong></th>
            <td>{informacionGps?.latitud || '-'}</td>
          </tr>
          <tr>
            <th><strong>Longitud:</strong></th>
            <td>{informacionGps?.longitud || '-'}</td>
          </tr>
          <tr>
            <th><strong>Dirección:</strong></th>
            <td>{informacionGps?.direccion || '-'}</td>
          </tr>
          <tr>
            <th><strong>Nivel de Batería:</strong></th>
            <td>{informacionGps?.nivel_bateria !== undefined && informacionGps.nivel_bateria !== null 
            ? `${informacionGps.nivel_bateria}%` 
            : '-'}</td>
          </tr>
          <tr>
            <th><strong>Último Reporte:</strong></th>
            <td>{informacionGps?.ultimo_reporte || '-'}</td>              
          </tr>
        </>
      );
    };

    const InformacionMovimientoPatio = ({ registro }) => {
      return (
        <>
          <tr>
                <td><strong>TRACTO</strong></td>
                <td></td>
              </tr>
              <tr>
                <th><strong>Modelo Tractor:</strong></th>
                <td>{registro.tractorModelo}</td>
              </tr>
              <tr>
                <th><strong>Marca Tractor:</strong></th>
                <td>{registro.tractorMarca}</td>
              </tr>
              <tr>
                <th><strong>Color Tractor:</strong></th>
                <td>{registro.tractorColor}</td>
              </tr>
              <tr>
                <th><strong>Placa Tractor:</strong></th>
                <td>{registro.tractorPlaca}</td>
              </tr>
              {/*<tr>
                <th><strong>Tipo Plataforma:</strong></th>
                <td>{registro.idPlataformaTipo === 1 ? "Naviera": registro.idPlataformaTipo === 2 ? "Terrestre" : "Terrestre naviera" }</td>
              </tr>*/}
              <tr>
                <th><strong>Tipo Plataforma:</strong></th>
                <td>{registro.remolqueTipo ? registro.remolqueTipo : "No especificado"}</td>
              </tr>
              <tr>
                <th><strong>Economico (tractor):</strong></th>
                <td>{registro.economicot}</td>
              </tr>  
              <tr>
                <th><strong>En Protocolo:</strong></th>
                <td>{registro.enProtocolo? "Si" : "No"}</td>
              </tr>            
              <tr>
                <td><strong>OPERADOR</strong></td>
                <td></td>
              </tr>
              <tr>
                <th><strong>Nombre Operador:</strong></th>
                <td>{registro.operadorNombre}</td>
              </tr>
              <tr>
                <th><strong>Medio Contacto:</strong></th>
                <td>{registro.operadorContacto}</td>
              </tr>
              <tr>
                <th><strong>Licencia:</strong></th>
                <td>{registro.operadorLicencia}</td>
              </tr>
              <tr>
                <td><strong>GPS (requerido)</strong></td>
                <td></td>
              </tr>
              <tr>
                <th><strong>Placa Remolque:</strong></th>
                <td>{registro.remolquePlaca}</td>
              </tr>
              <tr>
                <th><strong>Economico (remolque):</strong></th>
                <td>{registro.economicor }</td>
              </tr>
              <tr>
                <th><strong>Observaciones:</strong></th>
                <td>{registro.observaciones}</td>
              </tr>
              <tr>
                <th><strong>Evidencias:</strong></th>
                <td><ModalLay
                  tamanio={1200}
                  title="Evidencias colocación"
                  name={
                    <span
                      style={{
                        color: '#63e67b',
                        'font-size': '200%',
                      }}
                    >
                      <i className="fa fa-picture-o" />
                    </span>
                  }
                  formulario={MovimientoGpsEvidenciaModal}
                  datosForm={{ movimiento_id: registro.idMovimiento, gps: registro.gps }}
                /></td>
              </tr>
        </>
      );
    };

    const BotonesValidacionReset = ({idmovimiento, esfull}) => {
      return (
        <>
          <div className="button-group">
            <button className="validate-button" onClick={() => validarGps(idmovimiento, esfull)}>Validar Información</button>
            <button className="reset-button" onClick={() => resetGps(idmovimiento)}>Resetear Movimiento</button>
          </div>
        </>
      );
    };

    
  return (
    <>
      {idGps !== null && idGps !== undefined && idGps < 20 ? (
      <div className="special-gps-container">
        <h1 className="gps-info-title">Información Movimiento con GPS Virtual</h1>
        <table className="gps-info-table">
          <tbody>
            <MovimientoGps 
              idmovimiento={idmovimiento} 
              esfull={esfull} 
              registro={registro} 
              nombreGpsFull={nombreGpsFull} 
            />
            <InformacionMovimientoPatio
              registro={registro}
            />
          </tbody>
        </table>
        <BotonesValidacionReset
          idmovimiento={idmovimiento}
          esfull={esfull}
        />
      </div>
    ) : ( 
      !isEmpty(informacionGps) && 
      informacionGps.gps && 
      informacionGps.gps.id < 20 ? (
        <div className="special-gps-container">
          <h1 className="gps-info-title">Información Movimiento con GPS Virtual</h1>
          <table className="gps-info-table">
            <tbody>
              <MovimientoGps 
                idmovimiento={idmovimiento} 
                esfull={esfull} 
                registro={registro} 
                nombreGpsFull={nombreGpsFull} 
              />
              <InformacionMovimientoPatio
                registro={registro}
              />
            </tbody>
          </table>
          <BotonesValidacionReset
            idmovimiento={idmovimiento}
            esfull={esfull}
          />
        </div>
      ) : ( 
      !isEmpty(informacionGps) ? (  
        <div className="gps-info-container">
          <h1 className="gps-info-title">Información Movimiento con GPS en GpsGate</h1>
          <table className="gps-info-table">
            <tbody>  
              <MovimientoGps 
                idmovimiento={idmovimiento} 
                esfull={esfull} 
                registro={registro} 
                nombreGpsFull={nombreGpsFull} 
              /> 
              <InformacionGps
                informacionGps={informacionGps}
              />
              <InformacionMovimientoPatio
                registro={registro}
              />
            </tbody>
          </table>
          <BotonesValidacionReset
            idmovimiento={idmovimiento}
            esfull={esfull}
          />
        </div>) :  loading ? (
          <div className="loading-container">
            <h2 className="gps-info-title"><CircularProgress />
            <p>Cargando información del Movimiento y GPS...</p></h2>          
        </div>
        ) : mostrarMensaje && (<h2 className="gps-info-title">No se pudo recuperar información del GPS desde GpsGate</h2>)
      )
      )}        
    </>
  )
}

export default ValidacionMovimientoGps;